"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingSpinner = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const LoadingSpinner = exports.LoadingSpinner = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    className,
    small = false
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex content-center ".concat(className || ""),
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)("spinner", {
      "spinner-sm": small
    })
  }));
});